// extracted by mini-css-extract-plugin
module.exports = {"product-card":"components_product-card__vjX9V","separator":"components_separator__OvaJG"};